// The super-admin React SPA takes over the legacy Blade/Livewire panel's
// exact same URL space (tsc-group.org/dashboard/*) on the apex domain — see
// isLandingHost() in ./tenant.js for the apex/tenant-subdomain split this
// sits alongside. Checked before the landing/tenant branch so /dashboard/*
// never falls through to LandingApp.
export function isAdminPath() {
  if (typeof window === 'undefined') return false;
  return window.location.pathname.startsWith('/dashboard');
}
